// LayoutContext.js
import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';

const LayoutContext = createContext({});

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

export const LayoutProvider = ({ children }) => {
  const [fluid, setFluid] = useState(false);

  // Memoize the context value to prevent unnecessary re-renders
  const contextValue = useMemo(() => ({
    fluid,
    setFluid
  }), [fluid]);

  return (
    <LayoutContext.Provider value={contextValue}>
      {children}
    </LayoutContext.Provider>
  );
};